import React from "react";

const MissionVisionSection = () => {
  return (
    <section
      className="relative bg-cover bg-center bg-fixed py-20 md:py-32 px-4"
      style={{
        backgroundImage:
          "url('https://mhcockpit.com/Media/4%20Aviators/About/About-us.jpg')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative max-w-6xl mx-auto text-center text-white">
        {/* Title & Description */}
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          Our Mission, Vision & <span className="text-[#E43038]">Core Drive</span>
        </h2>
        <p className="max-w-3xl mx-auto text-base md:text-lg mb-16">
          We aim to deliver exceptional flight training that inspires, educates,
          and prepares every student to soar confidently upholding global
          aviation standards and values.
        </p>

        {/* Cards */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-10">
          {/* Mission Card */}
          <div className="relative w-full md:w-1/3 h-[600px] rounded-2xl overflow-hidden transform md:translate-y-10 shadow-lg hover:scale-[1.02] transition-all duration-300">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage:
                  "url('https://mhcockpit.com/Media/4%20Aviators/About/Our-Mission.jpg')",
              }}
            ></div>
            <div className="absolute inset-0 bg-black/10"></div>

            {/* Content at Bottom */}
            <div className="relative z-10 flex flex-col justify-end h-full p-8 text-left">
              <div>
                <h3 className="text-4xl font-bold mb-4 text-white">
                  Our<br /> <span className="text-[#FD9F27]">Mission</span>
                </h3>
                <p className="text-base text-gray-200 leading-relaxed">
                  To provide world-class aviation training that empowers
                  aspiring pilots with the knowledge, skills, and confidence
                  needed to excel in their aviation careers while maintaining
                  the highest standards of safety and professionalism.
                </p>
              </div>
            </div>
          </div>

          {/* Vision Card */}
          <div className="relative w-full md:w-1/3 h-[600px] rounded-2xl overflow-hidden transform md:-translate-y-10 shadow-lg hover:scale-[1.02] transition-all duration-300">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage:
                  "url('https://mhcockpit.com/Media/4%20Aviators/About/Our-Vision.jpg')",
              }}
            ></div>
            <div className="absolute inset-0 bg-black/10"></div>

            {/* Content at Bottom */}
            <div className="relative z-10 flex flex-col justify-end h-full p-8 text-left">
              <div>
                <h3 className="text-4xl font-bold mb-4 text-white">
                  Our<br /> <span className="text-[#FD9F27]">Vision</span>
                </h3>
                <p className="text-base text-gray-200 leading-relaxed">
                  To be the leading aviation academy recognized globally for
                  producing highly skilled, safe, and professional pilots who
                  shape the future of aviation through innovation, expertise,
                  and unwavering dedication to excellence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
